<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <i class="fas fa-arrow-left" style="font-size:20px;color:white;padding-bottom: 5px;cursor: pointer;" @click="goBack"> Back</i>
            <div class="card" style="padding: 20px; color: black">
                <div class="card-header border-0" style="text-transform: uppercase; text-align: center">
                    <h1>msacco ltd</h1>
                    <h1>p.o box 1919</h1>
                    <h1>thika</h1>
                </div><br>
                <div class="firstInstructions" style="text-transform: uppercase;margin-left: 40px;margin-bottom: 10px">
                    <h4 style="text-transform: capitalize;margin-left: 450px">Serial No: ...............</h4><br>
                    <h3 style="text-decoration: underline">members loan application and loan agreement form</h3>
                    <h3>this loan application must be fully completed in duplicate.<br> incomplete applications will neither be accepted or considered.</h3>
                </div>
                <div class="partA" style="margin-left: 40px;margin-bottom: 10px">
                    <h3 style="text-decoration: underline;text-transform: uppercase">part a</h3>
                    <div class="row">
                        <div class="col-6">I <span class="writings"> {{model.name}}</span></div>
                        <div class="col-6">Member No <span class="writings"> {{model.memberNo}}</span></div>
                    </div>
                    <p>ID No. <span class="writings">{{model.idNo}}</span></p>
                    <div class="row">
                        <div class="col-6">Address <span class="writings">{{model.address}}</span></div>
                        <div class="col-6">Tel <span class="writings">{{model.tel}}</span></div>
                    </div>
                    <p>Hereby request a loan of Ksh(figures) <span class="writings">{{model.loanAmountFigure}}</span></p>
                    <p>(in words) <span class="writings">{{model.loanAmountWord}}</span> Kenyan shillings</p>
                    <p>To be repaid in monthly installements of Ksh(figures) <span class="writings">{{model.monthlyInstallementsFigure}}</span></p>
                    <p>(in words) <span class="writings">{{model.monthlyInstallementsWord}} </span> Kenyan Shillings</p>
                    <p>No. of installements <span class="writings">{{model.noOfInstallements}} </span> including monthly interest @0.5%</p>
                    <p>The purpose of this loan is <span class="writings">{{model.purpose}}</span></p>
                    <div class="instructions">
                        <p>I hereby understand the Basic Rules and commitments applicable as listed below and the loan will be granted only according to these rules:</p>
                        <ol style="list-style-type: lower-roman; margin-left: 40px">
                            <li>Application must be in original form</li>
                            <li>Members total loan will be limited to a maximum of 3 times own shares (exclusive of any emergency loan),
                                and repayable for a period not exceeding 36 months</li>
                            <li>A member with outstanding loan must maintain the minimum monthly contributions</li>
                            <li>A member must have been an active contributor for a minimum period of six months and must have a minimum share holding of Ksh. 10,000.
                                The applying member and the guarantor(s) must be an active contributor for a period not less than six months</li>
                            <li>Any emergency loan(eg. Urgent business, education,hospitalization) will be repaid within a maximum period of 12 months
                                and at 12% interest per annum,(to a maximum of one's shares currently held in the society.</li>
                            <li>Lending is a subject to a society's capiatl and liquidity</li>
                            <li>Mmebrs should confirm lending rate in force as it is likely to vary from time to time</li>
                            <li>The committee may decline to grant to a member when he/she remains liable as a guarantor</li>
                            <li>Loans are considered once per month by the mangement committee</li>
                            <li>The guarantors must be members of the of the society and should not have guaranteed more than three loans</li>
                        </ol>
                    </div>
                    <div class="agreement" style="text-transform: uppercase">
                        <h3>name in full <span class="writings upper">{{model.name}} </span></h3>
                        <div class="row">
                            <div class="col-6"><h3>signed</h3></div>
                            <div class="col-6"><h3>date <span class="writings upper">{{model.date}} </span></h3></div>
                        </div>
                    </div>
                </div>
                <div class="partB" style="margin-left: 40px;margin-bottom: 10px">
                    <h3 style="text-decoration: underline;text-transform: uppercase">part b</h3>
                    <h4><em>(Repayment Guarantee)</em></h4>
                    <p style=" text-align: justify;">We the undersigned acting as the guarantors for the loan requested abov, hereby accept jointly and severally
                    liability for the repayment of the said loan or such part of it as may be granted in the event of the loanees default.
                    <br>We undestand that the ntire balance in default and cost appertaining to this loan shall be recovered by
                    paying cash or offsets against our shares, dividend and interests in the society or by attachment of our property.<br>
                    Should the loan guaranteed not be granted this guarantee automatically becomes null and void.</p>
                    <div style="margin-top: 10px">
                        <div class="row">
                            <div class="col-6">1) Name <span class="writings">{{model.guarantor1}} </span></div>
                            <div class="col-6">Member No <span class="writings">{{model.memberNo}} </span></div>
                        </div>
                        <p>Amount Guranteed <span class="writings">{{model.amountGuaranteed1}} </span></p>
                        <p>My total shares <span class="writings">{{model.shares}} </span></p>
                        <p>Other loan(s) & amount guaranteed <span class="writings">{{model.otherLoanGuanteed1}} </span></p>
                        <div class="row">
                            <div class="col-6">Signed</div>
                            <div class="col-6">Date <span class="writings">{{model.date}} </span></div>
                        </div>
                    </div>
                    <div style="margin-top: 10px">
                        <div class="row">
                            <div class="col-6">2) Name <span class="writings">{{model.guarantor2}} </span></div>
                            <div class="col-6">Member No <span class="writings">{{model.memberNo}} </span></div>
                        </div>
                        <p>Amount Guranteed <span class="writings">{{model.amountGuaranteed2}} </span></p>
                        <p>My total shares <span class="writings">{{model.shares}} </span></p>
                        <p>Other loan(s) & amount guaranteed <span class="writings">{{model.otherLoanGuanteed2}} </span></p>
                        <div class="row">
                            <div class="col-6">Signed</div>
                            <div class="col-6">Date <span class="writings">{{model.date}} </span></div>
                        </div>
                    </div>
                    <p>Each individual guarantor share holdings should not be less than one third of the loan guaranteed.</p>
                    <p>The total guaranteed amount (above) must be a minimum of the loan applied</p>
                </div>
                <div class="partC" style="margin-left: 40px;margin-bottom: 10px">
                    <h3 style="text-decoration: underline;text-transform: uppercase">part c</h3>
                    <h3 style="text-transform: uppercase"><em>(for credit committee)</em></h3>
                    <div class="treasurersRecommendation">
                        <p>Treasurer's Loan Appraisal & Recommendations</p>
                        <div class="row">
                            <div class="col-6">Loan No</div>
                            <div class="col-6">Date Received</div>
                        </div>
                        <p>Members shares</p>
                        <p>Amount currently requested</p>
                        <p>Total Loan will be</p>
                        <p>Any loans outstanding and amount</p>
                        <p>I certify that the total loan above is fully guaranteed and have checked the information contained in this form anf ound it to be correct</p>
                        <div class="row">
                            <div class="col-6">Amount recommended</div>
                            <div class="col-6">Date</div>
                        </div>
                        <div class="row">
                            <div class="col-6">Sign</div>
                            <div class="col-6">Date</div>
                        </div>
                    </div>
                </div>
                <div class="partD" style="margin-left: 40px;margin-bottom: 10px">
                    <h3 style="text-decoration: underline;text-transform: uppercase">part d</h3>
                    <h3 style="text-transform: uppercase"><em>(loan approval)</em></h3>
                    <p>We have today examined the above application in conjuction with the above remarks and decided as follows:</p>
                    <ol style="list-style-type: lower-roman; margin-left: 20px">
                        <li><p>Loan approved Ksh (figures)</p>
                        <p>(in words)</p></li>
                        <li>Recoverable in    monthly installements</li>
                        <li>Differed/Rejected for the following resons</li>
                    </ol>
                    <h4>Signed</h4>
                    <div class="row">
                        <div class="col-6">Chairman</div>
                        <div class="col-6">Date</div>
                    </div>
                    <div class="row">
                        <div class="col-6">Secretary</div>
                        <div class="col-6">Date</div>
                    </div>
                    <div class="row">
                        <div class="col-6">Member</div>
                        <div class="col-6">Date</div>
                    </div>
                    <h3>Treasurer's Record</h3>
                    <ol style="list-style-type: lower-roman; margin-left: 20px">
                        <li>Cheque No.</li>
                        <li><p>Amount Ksh (figures)</p>
                            <p>(in words)</p></li>
                        <li><p>Loan Recovery (figures)</p>
                            <p>with effect</p>
                        <p>Last Installement due date</p></li>
                        <li><p>Cheque dispatched on date</p>
                            <div class="row">
                                <div class="col-6">To</div>
                                <div class="col-6">Sign</div>
                            </div>
                            <div class="row">
                                <div class="col-6">By (sign)</div>
                                <div class="col-6">Date</div>
                            </div>
                        </li>
                    </ol>
                </div>
                <div class="completion" style="margin-left: 40px;margin-bottom: 10px">
                   <h3 style="text-decoration: underline;text-transform: uppercase">at completion</h3>
                    <p>The amount of this loan plus 6% interest per annum was fully paid up and this agreement terminated as at<br>
                    Date</p>
                    <p><strong>Signed (Treasurer)</strong></p>
                    <p><strong>Signed (Secretary)</strong></p>
                </div>
            </div>
        </base-header>
    </div>
</template>

<script>
    export default {
        name: "singleLoanSummary",
        data () {
            return {
                e1: 0,
                altLabels: true,
                editable: true,
                model: {
                    name: "sharon kirigo",
                    memberNo: "45",
                    idNo: "347937",
                    address: "1919 ni",
                    tel: "07893632",
                    date: "10/9/2019",
                    shares: "900000",
                    loanAmountWord: 'One Million',
                    loanAmountFigure: '1000000',
                    noOfInstallements: '36',
                    monthlyInstallementsWord: 'Twenty Thousand',
                    monthlyInstallementsFigure: '20000',
                    guarantor1: 'James Bond',
                    amountGuaranteed1: '30000',
                    otherLoanGuanteed1: 'None',
                    guarantor2: 'Nicole Richie',
                    amountGuaranteed2: '30000',
                    otherLoanGuanteed2: 'None',
                    purpose: 'The purpose of this loan is to conduct business and start a flower shop'
                },
            }
        },
        methods: {
            goBack(){
                this.$router.go(-1)
            },

        },
    }
</script>

<style scoped>
.writings{
    color: darkblue;
    padding-left: 30px;
    padding-right: 5px;
}
    .upper{
        text-transform: uppercase;
    }
</style>
